<template>
  <div>
    <div v-show="!isLoaded">
      <Loading ref="loadingSpinner"></Loading>
    </div>
    <div v-if="isLoaded">
      <ProductionTabs tabName="Mills"></ProductionTabs>
      <h3>Dostępne młyny</h3>
      <b-overlay :show="busy" rounded="sm">
        <div class="row">
          <template v-for="mill in mills">
            <DisplayMillItem
            :key="mill.id"
            :mill="mill"
            @TakeOutCouverture = "TakeOutCouverture"
            @RecipeChanged = "GetMillDetails" />
          </template>
        </div>
      </b-overlay>
    </div>
  </div>
</template>

<script>
import axios from "axios";


import Loading from "../../../components/Common/Loading";
import ProductionTabs from "../ProductionTabs";
import urlConfig from "../../../mixins/url";
import toastr from "../../../mixins/toastr";
import DisplayMillItem from './DisplayMillItem.vue'

export default {
  name: "DisplayMills",
  components: { Loading, ProductionTabs,DisplayMillItem },
  mixins: [urlConfig, toastr],
  mounted() {
    this.GetMillDetails();
  },
  data() {
    return {
      destinationCouvertureId: undefined,
      destinationCouvertureName: undefined,
      busy: false,
      mills: [],
      isLoaded: false,
    };
  },
  methods: {
    OpenModalForMixCouvertures(mill) {
      console.log(mill);
      this.destinationCouvertureId = mill.couvertureId;
      this.destinationCouvertureName = mill.couvertureName;
      this.$bvModal.show("MixCouvertures");
    },
    GetMillDetails() {
      var url = this.url.serverUrl + this.url.Mill.GetMillsDetails;
      var that = this;
      axios
        .get(url)
        .then(function (response) {
          that.mills = response.data;
          that.isLoaded = true;
        })
        .catch(function (e) {
          console.log(e);
          var ref = that.$refs.loadingSpinner;
          ref.ShowErrorMessage(e);
          that.isLoaded = false;
        });
    },
    TakeOutCouverture(couverture) {
      var that = this;
      if (confirm(`Czy napewno chcesz zlać kuwerturę: ${couverture.couvertureName}`)) {
        this.busy = true;
        var url = `${this.url.serverUrl}${this.url.Couverture.TakeOutCouverture + couverture.couvertureId}`;

        axios
          .post(url, {})
          .then(function () {
            couverture.couvertureId = undefined;
            couverture.couvertureName = undefined;
            that.busy = false;
          })
          .catch(function (e) {
            console.log(e);
            that.DisplayError("Błąd!", e);
          });
      }
    },
  },
};
</script>